/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useState} from "react";
import getSymbolFromCurrency from "currency-symbol-map";
import { OverlayTrigger, Tooltip  } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import 'react-lazy-load-image-component/src/effects/blur.css';
import VideoIframe from "../../../popup/VideoIframe";
import { toAbsoluteUrl } from "../../../../_helpers";
import { FaVideo } from "react-icons/fa";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { GrCertificate } from "react-icons/gr";
import { SendInquiry } from "../../../popup/sendInquiry";
import CertificateLink from "../../../popup/CertificateLink";
export const GridCardContentSimilarTheme3 = (props) => {
    const history = useHistory();
    const [showVideo, setShowVideo] = useState(false);
    const [openTax, setOpenTax] = useState(false);

    function handelDetails(data){
        history.push({  pathname: '/details', state:{
            StockID:data.STOCK_ID,
            diamond_type:data.COLOR?data.diamond_type:data.diamond_type + "F"
        }})
       
        window.scrollTo(0, 0)
    }

    function certificateLink(){
        if (props.CERTIFICATE_LINK){
            const certificate_link = props.CERTIFICATE_LINK
            return certificate_link
        }
    }
    function handleClose(event, reason) {
        setShowVideo(false)
    }
   
    function openVideoModal() {
        setShowVideo(true)
    }
    function Currency(){
        const cur = props.CURRENCY || props.themeData?.api_currency
        return getSymbolFromCurrency(cur) || ""
    }
    function numberWithCommas(x) {
        return x.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    return (
        <>
        <div
            className={`col-xl-3 col-lg-4 col-md-6 col-sm-12 mb-5  ${
                props.diamond_type === "N" ? "natTab" : "labTab"
            }`}
            key={props.STOCK_ID}
            id={props.STOCK_ID}
        >
            <div className="row m-0 card gridData">
                <div className="col-12 p-0 d-flex align-items-center justify-content-center bg-gray-200 mb-3" style={{height:"220px"}}>
                    <LazyLoadImage
                    className="img-fluid cursor-pointer"
                    onClick={() => handelDetails(props)}
                    src={props?.IMAGE || props?.sample}
                    alt={props?.SHAPE}
                    effect="blur"
                    placeholderSrc={toAbsoluteUrl(`/media/shape/noimage.png`)}
                    onError={(e) => {
                        const current = e.currentTarget;
                        const noImage = toAbsoluteUrl(`/media/shape/noimage.png`);

                        if (!current._fallbackApplied) {
                        current._fallbackApplied = true;

                        if (props?.sample && current.src !== props.sample) {
                            current.src = props.sample;
                        } else {
                            current.src = noImage;
                        }
                        } else {
                        current.src = noImage;
                        }
                    }}
                    />
                </div>
                <div className="col-12 text-truncate">
                    <OverlayTrigger
                        placement="top"
                        overlay={
                            <Tooltip id="tooltip">
                                {props.CARAT?props.CARAT.toFixed(2):""} {props.SHAPE}{" "}
                                {(props.FANCY_COLOR) ? (<>{props.FANCY_INTENSITY} {props.FANCY_OVERTONE} {props.FANCY_COLOR}</>): props.COLOR}{" "}
                                {props.CLARITY} {props.CUT}{" "}
                                {props.POLISH} {props.SYMMETRY} {props.FLUORESCENCE} <br />
                                M: {props.LENGTH?props.LENGTH.toFixed(2):0} x {props.WIDTH?props.WIDTH.toFixed(2):0} x {props.DEPTH?props.DEPTH.toFixed(2):0} T:{props.TABLE_PER?props.TABLE_PER.toFixed(2):0}%  D:{props.DEPTH_PER?props.DEPTH_PER.toFixed(2):0}%  R:{props.RATIO}
                            </Tooltip>
                        }
                    >
                        <span className="text-dark font-weight-bold text-capitalize font-size-h5">
                            <span className="pr-2">
                                {props.CARAT?props.CARAT.toFixed(2):""}
                            </span>
                            <span className="pr-2">{props.SHAPE}</span>
                            { (props.FANCY_COLOR ) ?
                                (
                                    <>
                                         <span className="pr-2">{props.FANCY_INTENSITY}</span>
                                         <span className="pr-2">{props.FANCY_OVERTONE}</span>
                                         <span className="pr-2">{props.FANCY_COLOR}</span>
                                    </>
                                ) : (
                                    <>
                                         <span className="pr-2">{props.COLOR}</span>
                                    </>
                                )
                            }
                            <span className="pr-2">{props.CLARITY}</span>
                            <span className="pr-2">{props.CUT}</span>
                            <span className="pr-2">{props.POLISH}</span>
                            <span className="pr-2">{props.SYMMETRY}</span>
                            <span className="pr-2">{props.FLUORESCENCE}</span>
                        </span>
                        
                    </OverlayTrigger>
                    <hr className="w-100 mt-3" />
                </div>
                <div className="col-12">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <div className="d-flex">
                            {props.VIDEO ? (
                                <div className="font-size-sm text-dark bg-primary-custom-light px-4 py-2 font-weight-bold mr-2">
                                    <FaVideo className="font-size-h6 cursor-pointer"  onClick={() => openVideoModal(props)} />
                                    <VideoIframe
                                        showVideo={showVideo}
                                        handleClose={handleClose}
                                        src={props.VIDEO }
                                    />
                                </div>
                            ) : (
                                <span id={props.VIDEO} > </span>
                            )}
                            {props.CERTIFICATE_NO ? <CertificateLink LAB={props.LAB}  CERTIFICATE_NO={props.CERTIFICATE_NO} CERTIFICATE_LINK={props.CERTIFICATE_LINK}  hideCerti GrCerti className="font-size-sm text-dark bg-primary-custom-light px-2 py-2 font-weight-bold d-flex"/> : ""}
                        </div>
                        {props.themeData && !props.themeData.ifm_no_price?<div className="font-size-h3 font-weight-bolder text-primary" style={{textAlign:'right'}}>
                            <OverlayTrigger
                                placement="top"
                                overlay={
                                    <Tooltip id="currency_t">
                                        {props.finalDisplayLabelTotalPricePerCarat || `${Currency()}/CT ${props.PRICE_PER_CTS?numberWithCommas(props.PRICE_PER_CTS):""}`}
                                    </Tooltip>
                                }
                            >
                            <span> {props.finalDisplayLabelTotalPrice || `${Currency()}${props.TOTAL_PRICE?numberWithCommas(props.TOTAL_PRICE):""}`}</span>
                            </ OverlayTrigger>
                            {props.taxBreakDown?(openTax?<IoIosArrowUp className="cursor-pointer ml-1" style={{fontSize:"14px"}} onClick={(e)=>{e.stopPropagation();setOpenTax(false)}}/>:<IoIosArrowDown className="cursor-pointer ml-1" style={{fontSize:"14px"}} onClick={(e)=>{e.stopPropagation();setOpenTax(true)}}/>):""}
                            {openTax && props.taxBreakDown?<div className="font-size-sm text-dark-50 font-weight-normal">{props.taxBreakDown}</div>:""}
                        </div>:""}
                    </div>
                    <hr className="w-100 mt-3" />
                </div>
                
                <div className="col-12 d-flex align-items-center justify-content-between mb-5">
                    <SendInquiry diamond_details={props} ipData={props.ipData} language={props.language}/>
                    {/* <button className="btn btn-primary font-weight-bold" onClick={() => handelDetails(props)}>
                        Send Inquiry
                    </button> */}
                    <button className="btn btn-secondary btn-sm font-weight-bold" onClick={() => handelDetails(props)}>
                        {props.language.CCMODE_THEME1_GRID_DETAILBTN}
                    </button>
                </div>
            </div>
        </div>
       
    </>
    );
};
